import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { OAuthResolveFlowRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { OAuthResolveFlowResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const oAuthResolveFlow = (request: OAuthResolveFlowRequest, options?: CashRequestOptions) =>
  post<OAuthResolveFlowRequest, OAuthResolveFlowResponse>('/2.0/cash/o-auth-resolve-flow', request, {
    ...options,
    rejectOnError: true,
  })
